import React, { useEffect, useState } from 'react';
import { useGlobal } from 'reactn';
import { useLocation, useHistory } from 'react-router-dom';
import QueryString from 'query-string';
import { notification, Modal } from 'antd';
import Button from '../../common/button/Button';
import Section from '../../common/section/Section';
import PastBillsTable from './PastBillsTable';
import Card from '../../common/card/Card';
import DateInput from '../../common/date/Date';
import CurrentBill from '../../common/footer/CurrentBill';
import GoPaperless from '../../common/footer/GoPaperless_Footer';
import SvcAccountHeader from '../svcAccountHeader/SvcAccountHeader';
import dayjs from 'dayjs';
import moment from 'moment';

const PastBills = () => {
  const [startDate, setStartDate] = useState(
    dayjs().subtract(2, 'year').startOf('month').format('YYYYMMDD')
  );
  const [endDate, setEndDate] = useState(
    dayjs().endOf('month').format('YYYYMMDD')
  );

  // determine if a bill should be opened on mount. MCWA will send emails to customers notifiying that their bill is available.
  // A specialized link will be included in the email that will take the customer to the portal to view the bill. This handles that scenario.
  const [fileUrl, setFileUrl] = useState(null);
  const location = useLocation();
  const history = useHistory();
  const [serviceAccounts] = useGlobal('serviceAccounts');
  const params = QueryString.parse(location.search);
  const showFileInUrl = !!params.filepath;
  
  useEffect(() => {
    if (showFileInUrl) {
      // get file path
      const { filepath } = params;

      // determine account number from file path
      const correspondingAccountNumber = parseInt(
        filepath.split('_')[0].split('/').pop(),
        10
      );

      // set selected account as the account from file path
      const correspondingAccount = serviceAccounts.find(
        (a) => a.data.ACCOUNT === correspondingAccountNumber
      );

      if (correspondingAccount) {
        // get list of bills from current account
        const bills = correspondingAccount.billingHistory?.data.map(
          (b) => b.FILEKEY
        );

        // find the actual file url
        const fileUrl = bills?.find((b) => b.includes(filepath));
        setFileUrl(fileUrl);
      } else {
        notification.error({
          message:
            'The file you requested does not exist or you do not have access to it.',
        });
        history.push('/user/past-bills');
      }
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [location ]);

  return (
    <div>
      <SvcAccountHeader />
      {fileUrl && (
        <Modal
          closable={null}
          open={showFileInUrl}
          bodyStyle={{ height: '80vh', minHeight: '700px' }}
          width="80vw"
          onCancel={() => {
            history.push('/user/past-bills');
          }}
          footer={[
            <Button
              key="ok"
              type="primary"
              className="w-full"
              onClick={() => {
                history.push('/user/past-bills');
              }}
            >
              Ok
            </Button>,
          ]}
        >
          <iframe
            title="iframe billing"
            className="w-full h-full"
            src={fileUrl}
          ></iframe>
        </Modal>
      )}
      <Section>
        <Card
          className="w-full"
          title="Past Payments"
          headerGroupClassName="flex justify-between items-center w-full"
          titleLinkClassName="text-xs ml-10 text-right text-white normal-case"
          ActionComponent_bottom={
            <div className="flex justify-between">
              <DateInput
                placeholder="Start Date"
                onChange={(momentDate) =>
                  setStartDate(momentDate.format('YYYYMMDD'))
                }
                value={moment(startDate)}
              />
              <DateInput
                className="ml-2"
                placeholder="End Date"
                onChange={(momentDate) =>
                  setEndDate(momentDate.format('YYYYMMDD'))
                }
                value={moment(endDate)}
              />
            </div>
          }
        >
          <PastBillsTable startDate={startDate} endDate={endDate} />
        </Card>
      </Section>
      <Section>
        <div className="flex flex-wrap">
          <GoPaperless className="w-full lg:w-1/3" />
          <CurrentBill className="w-full lg:w-2/3" />
        </div>
      </Section>
    </div>
  );
};

export default PastBills;
